import { ConfigFilterKey } from '@/types/userConfigs';

/**
 * The filter keys the app currently understands (mirrors the keys of
 * `filterAtomsToHydrateCallback`). Kept as a standalone leaf list rather than derived from that
 * registry to avoid a circular import (`consts/atomHydration` imports from `atoms/queries/userConfigs`).
 *
 * Saved user configs created before a key was renamed (e.g. the `playTypes` -> `playPatterns`
 * rename in EPT-33537) can still carry obsolete keys. Those are stripped when configs are read so
 * hydration/counting never encounters a key with no matching hydrate callback.
 */
export const CONFIG_FILTER_KEYS = [
  'competitionIds',
  'seasonIds',
  'teamIds',
  'playerIds',
  'positions',
  'metric',
  'metricDistributions',
  'gender',
  'periodRange',
  'gameRange',
  'startDate',
  'endDate',
  'gameType',
  'deselectedGameIds',
  'eventNames',
  'outcomes',
  'bodyParts',
  'playPatterns',
  'pitchStartZones',
  'pitchEndZones',
  'minObv',
  'maxObv',
  'minXg',
  'maxXg',
  'eventFilterGroups',
  'minAge',
  'maxAge',
  'minHeight',
  'maxHeight',
  'minMinutes',
  'maxMinutes',
  'nationality',
  'preferredFoot',
] as const satisfies readonly ConfigFilterKey[];

export const CONFIG_FILTER_KEY_SET: ReadonlySet<string> = new Set(CONFIG_FILTER_KEYS);
